export default function (obj) {
  const result = Object.keys(obj).map(function key() {
    return [Number(key), obj[key]];
  });
  if (result.length) {
    return result.length;
  }
  return '';
}
